import type { FaireProductEntity } from "../../entity_types/product";

export const p_e6m3fno0sn: FaireProductEntity = {
  token: "p_e6m3fno0sn",
  type: "product",
  name: "Lucy Dog Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/53174c196faba8f83743464ab2cc8b5fc73bddf0a4873354586bffc946fa1c4e/1558020916.png",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/51a910a2478e7818f08da3d39b6f522d3eaa4b3f4a80d4f3cee3ff91db63f707/1558020937.png",
    "https://cdn.faire.com/fastly/372273c8c76e4d609bd66e7ae17129709d824886cb5efc3bae1ba73b8459b738.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:06.010Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
